// import { Oval } from 'react-loader-spinner'
import loaderGif from '../assets/loader.gif';
const LoadingAction = () => {

    return (
        <div className="LoadingActionWrapper">
            <img style={{ borderRadius: '50%' }} src={loaderGif} alt="loader" />
            {/* <Oval
  height={70}
  width={70}
  color="#9B2915"
  wrapperStyle={{}}
  wrapperclassName=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="#ff000000"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>  */}
        </div>
    )
}

export default LoadingAction;